import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AssetType } from 'src/types/assets';
import { AssetService } from 'src/services/assets/asset.service';

type UseGetAllAssetArgs = {
  customerId: string;
  siteId: string;
};

export const useGetAllAssetsQuery = ({ customerId, siteId }: UseGetAllAssetArgs) => {
  const queryClient = useQueryClient();

  const isEnabled = !!siteId && !!customerId;

  const queryKey = isEnabled ? ['assets', `${customerId}-${siteId}`] : ['assets', 'empty'];

  const { data: assets } = useQuery<AssetType[]>({
    queryKey,
    queryFn: () => AssetService.getAll(customerId, siteId),
    staleTime: 1000 * 60 * 2, // 2 minute cache
    enabled: isEnabled,
    placeholderData: () => queryClient.getQueryData<AssetType[]>(queryKey),
  });

  return { assets };
};
